import React, { useState } from "react";
import { useSelector } from "react-redux";
import { NetworkAxios } from "../../API";
import CdxModal from "../../shared/modal/CdxModal";
import PostComment from "./postComment";

const EditComment = (props) => {
    const [comment, setComment] = useState(props.comment);
    const [editComment, setEditComment] = useState(props.cancelEdit || false);
    const loggedInUser = useSelector((state) => state.auth.loggedInUser);
    const [showDeleteModal, setShowDeleteModal] = useState(false);


    const handleDeleteComment = () => {
        NetworkAxios.get('/Comment/deletecomment/' + comment.id)
            .then(() => {
                setShowDeleteModal(false);
                props.reloadComments();
            }).catch(err => {
                console.log(err);
            });
    };

    return (
        editComment
            ? <PostComment
                commentFrom={props.commentFrom}
                editCommentContent={props.comment}
                reloadComments={props.reloadComments}
                showAssignment={props.showAssignment}
                editComment={editComment}
                cancelEdit={() => setEditComment(false)}
                solutionId={props.solutionId}
            />
            : <>
                {loggedInUser.userId === comment.userProfile.id &&
                    <div className="comment-actions">
                        <div className='edit-comment' onClick={() => { setEditComment(true); }}>
                            <div className="icon" />
                            Edit
                        </div>
                        {comment.replies && comment.replies.length <= 0 &&
                            <div className='delete-comment' onClick={() => setShowDeleteModal(true)}>
                                <div className="icon" />
                                Delete
                            </div>}
                    </div>
                }
                <div dangerouslySetInnerHTML={{ __html: props.comment.commentText }} />
                {comment.attachments.map((file) => {
                    return (
                        <div
                            key={`file${file.fileName}`}
                            style={{ paddingTop: "5px" }}
                        >
                            {" "}
                            <a href={file.filePath} target="_blank" rel="noreferrer">
                                {file.fileName}
                            </a>
                        </div>
                    );
                })}
                <CdxModal
                    show={showDeleteModal}
                    onHide={() => setShowDeleteModal(false)}
                    onClose={() => setShowDeleteModal(false)}
                    noBorder={false}
                >
                    <CdxModal.Header>Delete Post</CdxModal.Header>
                    <CdxModal.Body className="d-flex align-items-center">
                        Please confirm that you want to delete this post.
                    </CdxModal.Body>
                    <CdxModal.Footer>
                        <button className="cdx-btn" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                        <button className="cdx-btn" onClick={handleDeleteComment}>Yes</button>
                    </CdxModal.Footer>
                </CdxModal>
            </>
    );
};

export default EditComment;